export const FLOWPLAYER_STYLE_URL =
  '//cdn.flowplayer.com/releases/native/3/stable/style/flowplayer.css';
